import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../types/base-tool-types';

const toolName = 'list-workflow-tools' as const;

const argumentZod = z.object({});

export const listWorkflowToolsManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'List AI workflow tools',
  family: 'workflows',
  llmTool: {
    name: toolName,
    description:
      'Lists the node types an AI workflow may use — the builder allowlist. Each entry has a type, category, summary, whether it needs a credential connected, and whether the builder can author it (vs import-only). Call this before build-workflow or edit-workflow when unsure which integrations are available, rather than guessing a node type that will be rejected.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AIA_WORKFLOWS_MCP,
  confirmBeforeExecuting: false,
});

export type ListWorkflowToolsArgumentType = z.infer<typeof argumentZod>;
